import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { wizardClasses } from 'Views/Page/Content/Templates/WizardTemplates/wizardCommonStyles';
import WizardStandardHeader from 'Components/ComponentLibrary/Components/Uncategorized/WizardStandardHeader';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import DepositTypeCardGroup from 'Views/Page/Content/Templates/SelectTransferTypeTemplate/Content/DepositTypeCardGroup';
import { useHistory } from 'react-router-dom';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { hasRelationship } from 'Helpers/Affordances';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import { FDStack } from '@facet-wealth/design';

const useStyles = buildUseStyles('SelectTransferTypeTemplate', (theme) => ({
  root: {
    ...wizardClasses.root(theme),
  },
  container: {
    ...wizardClasses.container(theme),
  },
  content: {
    ...wizardClasses.content(theme),
  },
  title: {
    ...wizardClasses.title(theme),
  },
  subtitle: {
    ...wizardClasses.subtitle(theme),
    marginBottom: theme.spacing(5),
  },
  rolloverMessage: {
    textAlign: 'center',
  },
}));

const SelectTransferTypeTemplate = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const history = useHistory();
  const { loadPageContentLink } = usePageContentContext();

  const onClose = async () => {
    if (hasRelationship(resource, fr.relationships.redirectOnClose.name)) {
      await loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    } else {
      // Fallthrough case - unsure where to navigate to go to dashboard
      history.push('/');
    }
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <WizardStandardHeader
        color={'primary'}
        title={resource.attr('moduleName')}
        onClose={onClose}
      />
      <Box className={classes.container}>
        <Box className={classes.content}>
          <Title
            className={classes.title}
            text={resource.attr('title')}
          />
          <Subtitle
            className={classNames(classes.title, classes.subtitle)}
            text={resource.attr('subtitle')}
            weight={'book'}
          />
          <FDStack spacing={4} direction={'column'} alignItems={'center'}>
            <DepositTypeCardGroup depositTypesCollection={resource.attr('accountTypes')} />
            <RichTextDisplay className={classes.rolloverMessage} content={resource.attr('rolloverTransferMessage')} />
          </FDStack>
        </Box>
      </Box>
    </Box>
  );
};

SelectTransferTypeTemplate.defaultProps = {
  className: '',
};

SelectTransferTypeTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default SelectTransferTypeTemplate;
